import React, { useEffect, useState } from 'react';

export default function AppUpdateNotice() {
  const [registration, setRegistration] = useState(null);
  const [updating, setUpdating] = useState(false);
  useEffect(() => {
    const ready = event => setRegistration(event.detail);
    window.addEventListener('tap-update-ready', ready);
    return () => window.removeEventListener('tap-update-ready', ready);
  }, []);
  useEffect(() => {
    if (!updating || !navigator.serviceWorker) return;
    const reload = () => window.location.reload();
    navigator.serviceWorker.addEventListener('controllerchange', reload, { once: true });
    registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
    return () => navigator.serviceWorker.removeEventListener('controllerchange', reload);
  }, [updating, registration]);
  if (!registration?.waiting) return null;
  return <aside className="fixed top-3 left-3 right-3 z-[60] mx-auto max-w-lg rounded-xl border border-border bg-card p-4 shadow-lg" aria-label="앱 업데이트" role="status">
    <p className="font-semibold">새 버전이 준비되었습니다</p>
    <p className="text-sm text-muted-foreground mt-1">입력 중인 내용을 저장한 뒤 업데이트해 주세요.</p>
    <div className="flex gap-3 mt-3"><button className="club-button" disabled={updating} onClick={() => setUpdating(true)}>{updating ? '업데이트 중…' : '업데이트'}</button><button className="club-text-link" disabled={updating} onClick={() => setRegistration(null)}>나중에</button></div>
  </aside>;
}
